import { OrderObject } from 'src/app/models/orders/order-object.model';
import { OrderTable } from 'src/app/models/orders/order-table'
import { ProcessTableObject } from 'src/app/models/orders/order-details-process/process-table/process-table-object.model';
import { ProcessErrorObject } from 'src/app/models/orders/order-details-process/process-details/process-error-object.model';
import { ProcessActivityObject } from 'src/app/models/orders/order-details-process/process-details/process-activity-object.model';
import { OrderDependencyObject } from 'src/app/models/orders/order-details-dependencies/order-dependencies.model';
import { isUndefined } from 'util';
import { Filter } from '../filters/filters.dto';
import { AppService } from 'src/app/app.service';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';

import { OrderDependencyConverter } from 'src/app/services/api/orders/specific-order/dependencies-list.converter';
import { TechnicalSubprocessObject } from 'src/app/models/orders/order-details-process/process-details/technical-subprocess-object.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { OrderDetailsGeneralCancelRequest } from 'src/app/models/orders/order-details-general/order-details-general-cancel-request.model';
import { SitesObject } from 'src/app/models/orders/order-details-sites/sites-tab-object-model';
import { map } from 'rxjs/operators';
import { SitesTableObject } from 'src/app/models/orders/order-details-sites/sites-table/sites-object.model';
import { OrderDetailsSitesContactsConverter } from './specific-order/order-details-sites-contacts.converter';
import { OrderDetailsSitesAddressesConverter } from './specific-order/order-details-sites-addresses.converter';
import moment from 'moment';
import { FetchApiService } from '../core/fetch-api.service';

export interface Order {
  namingId: string;
  createdAt: string;
  lastModifiedAt: string;
  state: string;
  specification: string;
  action: string;
  crm: string;
  isp: string;
  externalId: string;
}

export interface OrderTree {
  crmId: string;
  orderId: string;
  type: {
    name: string;
  };
  name: string;
  description: string;
  operation: string;
  status: string;
  completed: boolean;
  dependencies: boolean;
  children: OrderTree[];
}

export interface OrderSummary {
  externalId: string;
  inventoryId?: string;
  id?: string;
  type: {
    name: string;
  };
  action?: string;
  domain?: string;
  status?: string;
  state?: string;
  urgent?: boolean;
  project?: string;
  priority?: number;
  createdAt?: string;
  expectedStartDate?: string;
  requestStartDate?: string;
  cancellationDate?: string;
  cancellationMotive?: string;
  cancelledBy?: string;
  hasDependencies?: boolean;
  specification?: string;
  processes?: {
    id: number;
    type: string;
    name: string;
    orderId: string;
    status: string;
    originIdScai: string;
  }[];
  listsCharacteristic?: {
    in: any[];
    out: any[];
  };
  childs?: {
    action: string;
    id: string;
    type: string;
    specification: string;
    name: string;
    domain: string;
  }[];
  cancelled?: boolean;
  cancellable?: boolean;
  serviceRef?: string;
  isReload?: boolean;
}


export interface OrderData {
  'page': number;
  'total': number;
  'elements': Order[];
}
export interface Notification {
  'notificationId': string;
  'notificationDate': string;
  'externalOrderId': string;
  'traceId': string;
  'sourceSystem': string;
  'targetSystem': string;
  'destinationType': string,
  'destinationHttpMethod': string,
  'destinationUri': string,
  'destinationExchange': string,
  'destinationRouteKey': string,
  'operationResult': string;
  'notificationResult': string,
  'message': string,
  'messageString': string;
  'headers': string
}

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  appData: any;

  constructor(
    private httpClient: HttpClient,
    appService: AppService,
    private contactsConverter: OrderDetailsSitesContactsConverter,
    private addressesConverter: OrderDetailsSitesAddressesConverter,
    private fetchApiService: FetchApiService
  ) {
    this.appData = appService.settings;
  }

  public async getOrderList(filter: Filter): Promise<OrderTable> {
    let orderList = new Array<OrderObject>();
    let orderTable;
    try {
      console.debug('Filtro generado: ' + JSON.stringify(filter));

      const response = { data: undefined };

      const orders: any = JSON.parse(JSON.stringify(response.data));

      if (!isUndefined(orders) && !isUndefined(orders.elements)) {
        orderList = this.toOrderList(orders);
        orderTable = new OrderTable(orderList, orders.page, orders.total);
      }
    } catch (error) {
      console.error(error);
    }

    return orderTable;
  }

  private toOrderList(orders: any): OrderObject[] {
    const orderList = new Array<OrderObject>();
    orders.elements.forEach((order: any) => {
      const orderObject = new OrderObject(order.orderId, new Date(order.requestStartDate), new Date(order.modifiedAt),
        OrderStatusObject.createWithStatus(order.state), order.businessName, order.businessCustomerId,
        order.businessServiceIds, order.crmId, order.project);

      orderList.push(orderObject);
    });
    return orderList;
  }

  public getPriorityList(): Array<number> {
    const list = new Array<number>(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20);
    return list;
  }

  public getVoidProcessTableList(): Array<ProcessTableObject> {
    const list = new Array<ProcessTableObject>();
    return list;
  }

  public getErrorProcess1(): ProcessErrorObject {
    const error = new ProcessErrorObject('IA21', 'Incidencia instalación FTTH', new Date());
    return error;
  }

  public getErrorProcess2(): ProcessErrorObject {
    const error = new ProcessErrorObject('COBERTURA INFO', 'Fallo del instalador', new Date('1998/01/07'));
    return error;
  }

  public getFinishedActivityProcess(): ProcessActivityObject {
    const type = 'reserve';
    const status = 'end';
    const errorList = new Array<ProcessErrorObject>();
    const actualDuration = 86400000;
    const expectedDuration = 5268700;
    const startDate = new Date();
    const completedDate = new Date();
    const information = 'Sin información';
    const activity = new ProcessActivityObject(type, status, errorList, 0, actualDuration, expectedDuration,
      startDate, completedDate, information, true, false, false, true);
    return activity;
  }

  public getErrorActivityProcess(): ProcessActivityObject {
    const type = 'provision';
    const status = 'error';
    const errorList = new Array<ProcessErrorObject>();
    errorList.push(this.getErrorProcess1());
    errorList.push(this.getErrorProcess2());
    const actualDuration = 7200000;
    const expectedDuration = 86400000;
    const startDate = new Date();
    const information = 'Sin información';
    const activity = new ProcessActivityObject(type, status, errorList, 0, actualDuration, expectedDuration,
      startDate, null, information, false, false, false, true);
    return activity;
  }

  public getNotStartedActivityProcess(type: string): ProcessActivityObject {
    const status = 'start';
    const errorList = new Array<ProcessErrorObject>();
    const actualDuration = 123456789;
    const expectedDuration = 1234567890;
    const startDate = new Date();
    const information = 'Sin información';
    const activity = new ProcessActivityObject(type, status, errorList, 0, actualDuration, expectedDuration,
      startDate, null, information, false, false, false, false);
    return activity;
  }

  public getStartedActivityProcess(type: string): ProcessActivityObject {
    const status = 'start';
    const errorList = new Array<ProcessErrorObject>();
    const actualDuration = 799200000;
    const expectedDuration = 86400000;
    const startDate = new Date('2019/07/23');
    const information = 'Sin información';
    const activity = new ProcessActivityObject(type, status, errorList, 0, actualDuration, expectedDuration,
      startDate, null, information, false, false, false, true);
    return activity;
  }

  public getSubprocessList(): Array<TechnicalSubprocessObject> {
    const list = new Array<TechnicalSubprocessObject>();
    list.push(new TechnicalSubprocessObject('Wait for CFSs completion', 'receive_task', 'waiting', new Date('2019/06/03'), false));
    list.push(new TechnicalSubprocessObject('Wait for CFSs completion', 'MULTI_INSTANCE_ACTIVITY', 'executing', new Date('2019/06/02'),
      false));
    list.push(new TechnicalSubprocessObject('Call decompounder', 'AUTOMATIC_TASK', 'aborted', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Acquire Inventory Data', 'AUTOMATIC_TASK', 'ready', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('NOT_PROC_INI', 'call_activity', 'completed', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Notificate', 'AUTOMATIC_TASK', 'completed', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Check notification', 'AUTOMATIC_TASK', 'completed', new Date('2019/06/01'), true));
    return list;
  }

  public getSubprocessList2(): Array<TechnicalSubprocessObject> {
    const list = new Array<TechnicalSubprocessObject>();
    list.push(new TechnicalSubprocessObject('NOT_PROC_END', 'CALL_ACTIVITY', 'completed', new Date('2019/06/03'), true));
    list.push(new TechnicalSubprocessObject('Notificate', 'AUTOMATIC_TASK	', 'executing', new Date('2019/06/02'), true));
    list.push(new TechnicalSubprocessObject('Check notification	', 'AUTOMATIC_TASK', 'completed', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Get Billing Data', 'AUTOMATIC_TASK', 'ready', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Call coordinate', 'AUTOMATIC_TASK	', 'completed', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Notificate', 'AUTOMATIC_TASK', 'completed', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Wait for RFSs completion', 'MULTI_INSTANCE_ACTIVITY', 'completed', new Date('2019/06/01'),
      true));
    list.push(new TechnicalSubprocessObject('Wait for CFSs completion', 'RECEIVE_TASK', 'completed', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Wait for CFSs completion', 'RECEIVE_TASK', 'completed', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Call decompounder', 'AUTOMATIC_TASK', 'completed', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Acquire Inventory Data', 'AUTOMATIC_TASK', 'waiting', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('NOT_PROC_INI', 'CALL_ACTIVITY', 'completed', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Notificate', 'AUTOMATIC_TASK', 'aborted', new Date('2019/06/01'), true));
    list.push(new TechnicalSubprocessObject('Check notification	', 'AUTOMATIC_TASK', 'completed', new Date('2019/06/01'), true));
    return list;
  }

  public async getDependenciesList(orderId: string): Promise<Array<OrderDependencyObject>> {
    const list = new Array<OrderDependencyObject>();

    try {

      const treeResponse = { data: undefined };
      const dependencies: any = JSON.parse(JSON.stringify(treeResponse.data));

      if (!isUndefined(dependencies)) {

        for (const dependency of dependencies) {
          list.push(new OrderDependencyConverter().convert(dependency));
        }
      }
      return list;
    } catch (error) {
      console.error(error.data);
    }
  }

  getOrders(body: any): Observable<OrderData> {
    return this.httpClient.post<OrderData>(`${this.appData.webApi}/orders/getOrders`, body, {});
  }

  getOrdersCsv(body: any): Promise<Response> {
    return this.fetchApiService.bodyStreamingRequest(`${this.appData.webApi}/orders/getOrdersCsv`,'POST', body, {});
  }

  getOrderTree(orderId: string): Observable<OrderTree> {
    return this.httpClient.get<OrderTree>(`${this.appData.webApi}/orders/${orderId}/tree`);
  }

  getProductOrderSummary(namingId: string): Observable<OrderSummary> {
    return this.httpClient.get<OrderSummary>(`${this.appData.webApi}/orders/productOrder/${namingId}/summary`);
  }

  getServiceOrderSummary(namingId: string): Observable<OrderSummary> {
    return this.httpClient.get<OrderSummary>(`${this.appData.webApi}/orders/serviceOrder/${namingId}/summary`);
  }

  getProductCharacteristics(productId: string): Observable<any> {
    return this.httpClient.get<CharacteristicsObject>(`${this.appData.webApi}/orders/productOrder/productOrders/${productId}/itemsInfo`);
  }

  getServiceCharacteristics(serviceId: string): Observable<any> {
    return this.httpClient.get(`${this.appData.webApi}/orders/serviceOrders/${serviceId}/itemsInfo`);
  }

  cancelOrder(orderId: string, cancellationMotive: string, externalId: string, cancelledBy: string): Observable<any> {
    return this.httpClient.post(`${this.appData.webApi}/orders/productOrder/productOrders/${orderId}/cancel`,
      {
        externalId,
        cancellationDate: moment().format(this.appData.dateFormat),
        cancellationMotive,
        cancelledBy,
      });
  }

  getProductSites(productId: string): Observable<Array<SitesObject>> {
    return this.httpClient.get<any>(`${this.appData.webApi}/orders/products/${productId}/sites`).pipe(
      map(sitesJSON => {
        const allSites = new Array<SitesObject>();
        let id = 0;

        if (!isUndefined(sitesJSON)) {
          for (const site of sitesJSON) {
            const newSite = new SitesTableObject(id, site.name, site.roles.toString(), site.contacts.length);
            const contacts = this.contactsConverter.convert(site);
            const addressesWithCorrectFormat = this.addressesConverter.convert(site);
            allSites.push(new SitesObject(newSite, contacts, addressesWithCorrectFormat));
            id++;
          }
        }
        return allSites;
      })
    );
  }

  getServiceSites(serviceId: string): Observable<Array<SitesObject>> {
    return this.httpClient.get<any>(`${this.appData.webApi}/orders/services/${serviceId}/sites`).pipe(
      map(sitesJSON => {
        const allSites = new Array<SitesObject>();
        let id = 0;

        if (!isUndefined(sitesJSON)) {
          for (const site of sitesJSON) {
            const newSite = new SitesTableObject(id, site.name, site.roles.toString(), site.contacts.length);
            const contacts = this.contactsConverter.convert(site);
            const addressesWithCorrectFormat = this.addressesConverter.convert(site);
            allSites.push(new SitesObject(newSite, contacts, addressesWithCorrectFormat));
            id++;
          }
        }
        return allSites;
      })
    );
  }

  getDependencies(serviceId: string): Observable<Array<OrderDependencyObject>> {
    return this.httpClient.get<any>(`${this.appData.webApi}/orders/services/${serviceId}/dependencies`).pipe(
      map(dependenciesJSON => {
        const list = new Array<OrderDependencyObject>();

        const dependencies: any = JSON.parse(JSON.stringify(dependenciesJSON));

        if (!isUndefined(dependencies)) {

          for (const dependency of dependencies) {
            list.push(new OrderDependencyConverter().convert(dependency));
          }
        }

        return list;
      })
    );
  }

  getProductOrder(id: string): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/orders/productOrder/${id}`);
  }

  getServiceOrder(id: string): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/orders/serviceOrder/${id}`);
  }

  getAssociatedProductOrders(productRef: string, sort: string): Observable<any[]> {
    let params = new HttpParams();
    params = params.append("sort", sort);
    return this.httpClient.get<any[]>(`${this.appData.webApi}/orders/productOrder/getAssociatedProductOrders/${productRef}`, { params });
  }

  getOrderNotifications(filterMap: any): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/notifications/v1/notification/filter`, filterMap);
  }

  retryNotification(id: string, notification: Notification): Observable<string> {
    const headers: Object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'text'
    };
    return this.httpClient.put<string>(`${this.appData.webApi}/notifications/v1/notification/${id}/retry`, notification, headers);
  }

  getDependencyInfo(referencePath: string): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/orders/${referencePath}`);
  }

  getProductOrderSummaryFromServiceRef(serviceRef: string): Observable<OrderSummary> {
    return this.httpClient.get<OrderSummary>(`${this.appData.webApi}/orders/productOrder/getFromServiceOrder/${serviceRef}/summary`);
  }

}
